import { useEffect, useState } from "react";

// The browser offers installation once; keep that offer from page load so the button can use it later.
let deferred = null;
const EVENT = "yh-install-change";

export const listenInstall = () => {
  if (typeof window === "undefined") return;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    window.dispatchEvent(new Event(EVENT));
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    window.dispatchEvent(new Event(EVENT));
  });
};

const standalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIos = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const useInstall = () => {
  const [, tick] = useState(0);
  useEffect(() => {
    const f = () => tick((n) => n + 1);
    window.addEventListener(EVENT, f);
    return () => window.removeEventListener(EVENT, f);
  }, []);
  const prompt = async () => {
    if (!deferred) return false;
    const e = deferred;
    deferred = null;
    await e.prompt();
    const choice = await e.userChoice.catch(() => null);
    window.dispatchEvent(new Event(EVENT));
    return choice?.outcome === "accepted";
  };
  return { installed: standalone(), canPrompt: Boolean(deferred), prompt };
};
